// extracted by mini-css-extract-plugin
export default {"l":"_95e8ad73d6"};